module.exports = __webpack_public_path__ + "images/illustrations/reach-icon-stopwatch-2c3ae18ffe72687cdb4f91471213a99d.svg";